import { Component,HostListener, ElementRef, EventEmitter, Input, OnChanges, OnDestroy, Renderer2, Output, SimpleChanges, ViewChild } from '@angular/core';
import { Subject } from 'rxjs';
import * as Highcharts from 'highcharts';
import { takeUntil } from 'rxjs/operators';
import { SnapshotService } from '../../Services/snapshot.service';
import { CustomsnapshotService } from '../../Services/customsnapshot.service';
import * as _ from 'lodash';
import { LoaderService } from 'src/app/common/services/loader.service';


@Component({
  selector: 'app-custom-output-icons',
  templateUrl: './custom-output-icons.component.html',
  styleUrls: ['./custom-output-icons.component.css']
})
export class CustomOutputIconsComponent implements OnChanges, OnDestroy {
  constructor(
    public _configService: SnapshotService,
    private _customService: CustomsnapshotService,
    private renderer: Renderer2,
    private _loaderService: LoaderService
  ) {

  }
  @Input() data: any;
  @Input() widgetchartname: string = "";
  @Input() id: any;
  @Input() alldata: any;
  @Input() datafromLayout: any;
  @Input() multimetricselect: boolean = false;
  @Output() dataBarsUpdated = new EventEmitter<{ item: any, status: boolean }>();
  @Input() legendItems: any[] = [];
  @Input() legendTable: { cohorts: string[]; rows: Array<{ name: string; color: string; values: { [cohort: string]: string } }> } | null = null;
  trendlineOutputView:number=0;
legendDropdownOpen = false;
clusterLegendDropdownOpen = false; 
@Input() isDisabled: boolean = false;
hiddenSeriesMap: { [name: string]: boolean } = {};

@HostListener('document:click')
onLegendDocumentClick(): void { this.legendDropdownOpen = false;
    this.clusterLegendDropdownOpen = false;
 }

@HostListener('window:kpi-legend-open', ['$event'])
onOtherLegendOpen(e: any): void {
  if (e.detail?.id !== this.id) {
    this.legendDropdownOpen = false;
    this.clusterLegendDropdownOpen = false;
  }
}

toggleLegendDropdown(event: Event): void {
  event.stopPropagation();
  this.legendDropdownOpen = !this.legendDropdownOpen;
  if (this.legendDropdownOpen) {
    window.dispatchEvent(new CustomEvent('kpi-legend-open', { detail: { id: this.id } }));
  }
}
toggleClusterLegendDropdown(event: Event): void {
  event.stopPropagation();
  this.clusterLegendDropdownOpen = !this.clusterLegendDropdownOpen;
  if (this.clusterLegendDropdownOpen) {
    window.dispatchEvent(new CustomEvent('kpi-legend-open', { detail: { id: this.id } }));
  }
}
toggleSeries(leg: any, event: Event): void {
  event.stopPropagation();
  if (leg.isKPI) return;
  const containerId = 'chart-container' + this.id;
  const chart = (Highcharts as any).charts.find(
    (c: any) => c && c.renderTo && c.renderTo.id === containerId
  );
  if (!chart) return;
  const series = chart.series.find((s: any) => s.name === leg.name);
  if (!series) return;
  const newVisible = !series.visible;
  series.setVisible(newVisible, true);
  // Spread creates a new object → Angular detects the change
  this.hiddenSeriesMap = { ...this.hiddenSeriesMap, [leg.name]: !newVisible };
}

  infoTextTitle: string = '';
  showExpandPopup = false;
  visualization: any;
  infoClicked: boolean = false;
  infoTextMessage: string = "";
  EnableDatabar:boolean=false;
  metricdropdownOutput:boolean=false;
  // id: any;
  item: any;
  elementList: any = false;
  customization: any = {}
  isdropDown: any = false;
  dropDownItems: any = [];
  inputPopup: boolean = false;
  brandList: any = []
  selectedBrand: any;
  metricList: any[] = [];
  selectedMetric: any;
  originalWidgetChartName: string = '';
  isSingleFunnelOrMultipleWidget: boolean = false;
  isSingleFunnel: boolean = false;
  defaultSorting = 0;
  isSortAvailable : boolean = false;

  // --- Cached properties so the template never calls methods or reads service
  //     properties on every change-detection cycle ---
  isMultiSnapshot: boolean = false;
  isAudienceSnapshot: boolean = false;
  isMultiOrCohort: boolean = false;   // multiSnapshot OR multiCohort
  isFunnelChart: boolean = false;
  isPropellerChart: boolean = false;
  additionalGroupLength: number = 0;
  cachedPopupWidgetName: string = '';
  cachedBrandDisplay: string = 'Select';
  uniqueBrandList: any[] = [];

  private destroy$ = new Subject<void>();

  private _refreshSnapshotTypeFlags() {
    const t = (this._configService.selectedSnapshotType ?? '').toLowerCase();
    this.isMultiSnapshot = t.includes('multi');
    this.isAudienceSnapshot = t.includes('audience');
    this.isMultiOrCohort = this.isMultiSnapshot || !!this._configService.multiCohort;
  }

  ngOnInit() {
    this._refreshSnapshotTypeFlags();
    this._customService.getBrandList(this.id).pipe(takeUntil(this.destroy$)).subscribe((list) => {
      let brandList = list[0];
      this.selectedBrand = list[1];
      this._customService.funnelChartSelectedItem$.next(this.selectedBrand || '');
      this.brandList = [];
      if (brandList) {
        brandList.forEach((b: any) => {
          this.brandList.push({
            option: b,
            checked: b == this.selectedBrand ? true : false
          })
        })
      }
      this.uniqueBrandList = this.getUniqueBrand(this.brandList);
      this.cachedBrandDisplay = this.getBrand();
    });
    let customizationProperties = JSON.parse(this.data?.customizationProperties);
    this.trendlineOutputView=customizationProperties.trendlineOutputView;
    const isClusterBar = this.widgetchartname?.toLowerCase().includes('cluster');
if (isClusterBar && this.isAudienceSnapshot) {
  this.trendlineOutputView = 2;
}
    const isSpiderChart = this.widgetchartname?.toLowerCase().includes('spider');
    const isMultipleBrands = this._configService.selectedSnapshotType?.toLowerCase().includes('multi');
    if (isSpiderChart && (isMultipleBrands || this.isAudienceSnapshot)) {
      this.trendlineOutputView = 2;
    }
    const isMultipleMarkets = this._configService.selectedSnapshotType?.toLowerCase().includes('multiple markets');
    const isStackedChart = this.widgetchartname?.toLowerCase().includes('stack');
    if (isStackedChart && (isMultipleMarkets || (this.isAudienceSnapshot && this._configService.multiCohort))) {
      this.trendlineOutputView = 2;
    }
    const isFunnelChart = this.widgetchartname?.toLowerCase().includes('funnel');
    if (isFunnelChart && isMultipleMarkets) {
      this.trendlineOutputView = 2;
    }
    this.EnableDatabar = customizationProperties.isBarDataEnable;
  }

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  ngOnChanges(changes: SimpleChanges): void {
  if (changes['legendItems']) {
    this.hiddenSeriesMap = {};
  }
    if (changes['data']) {
      this.customization = JSON.parse(this.data?.customizationProperties);
    this.trendlineOutputView=this.customization .trendlineOutputView;
    const isClusterBar = this.widgetchartname?.toLowerCase().includes('cluster');
    if (isClusterBar && this.isAudienceSnapshot) {
      this.trendlineOutputView = 2;
    }

      const isSpiderChart = this.widgetchartname?.toLowerCase().includes('spider');
      const isMultipleBrands = this._configService.selectedSnapshotType?.toLowerCase().includes('multi');
      if (isSpiderChart && (isMultipleBrands || this.isAudienceSnapshot)) {
      this.trendlineOutputView = 2;
    }
    const isMultipleMarkets = this._configService.selectedSnapshotType?.toLowerCase().includes('multiple markets');
    const isStackedChart = this.widgetchartname?.toLowerCase().includes('stack');
    if (isStackedChart && (isMultipleBrands || isMultipleMarkets || (this.isAudienceSnapshot && this._configService.multiCohort))) {
      this.trendlineOutputView = 2;
    }
    const isFunnelChart = this.widgetchartname?.toLowerCase().includes('funnel');
    if (isFunnelChart && isMultipleMarkets) {
      this.trendlineOutputView = 2;
    }

        this.metricdropdownOutput = this.data.metricdropdownOutput != 0 && !!this.data.metricdropdownOutput;
      this.additionalGroupLength = this.LengthOf(this.customization?.additionalGroup);
      this._refreshSnapshotTypeFlags(); // snapshot type may update between data reloads
      this.cachedPopupWidgetName = this.getPopupWidgetName(this.data);
      if( this.data.elementList != undefined ){
        this.data.elementList.forEach((item:any) => {
          if(item.item == "Sorting"){
            this.isSortAvailable = true;
          }
        })
      }

      if( this.data.sortingOrder != undefined ){
        this.data.sortingOrder = (this.data.sortingOrder + 1)%3;
      }
      if (this.customization?.additionalGroup && this.data.elementList == undefined || this.data.elementList?.length == 0) {
        this.elementListItems = []; // reset to prevent stale items from a previous widget being pushed again
        // if (this.customization?.showLegend !== undefined) {
        //   // Add the "Show Legend" property to the additionalGroup object

        //   this.customization.additionalGroup['showLegend'] = this.customization.showLegend;
        // }
        // let elementListItems = Object.keys(this.customization?.additionalGroup);
        let elementListItems = Object.keys(this.customization?.additionalGroup || {}).filter(
          key => this.customization.additionalGroup[key] === true
              || (key === 'InfoText' && !!this.customization.additionalGroup[key])
        );
        // elementListItems.push(Object.keys(this.customization?.additionalGroup || {}).filter(
        //   key => this.customization.additionalGroup[key] === true
        // ))
        if (elementListItems) {
          elementListItems.forEach((e: any) => {
            // if(e == "FreezeFirstColumn" || e=="FreezeFirstRow" || e=="HideNA" || e=="Transpose"){
            //   this.elementListItems.push(
            //     {
            //       item: e,
            //       selected: this.customization?.additionalGroup[e],
            //       isdropDown: false,
            //       options: []
            //     }
            //   );
            // }
            // else if( e== "ColumnHeaderSorting"){
            //   this.elementListItems.push(
            //     {
            //       item: e,
            //       selected: false,
            //       isdropDown: false,
            //       options: [
            //         { item: "Ascending", selected: false },
            //         { item: "Descending", selected: false },
            //         { item: "Default", selected: true },
            //       ]
            //     }
            //   );
            // }
            if (e != "Sorting" && e != "ColumnHeaderSorting" && e != "TrendlineinExports" && e != "showLegend") {
              this.elementListItems.push(
                {
                  item: e,
                  selected: e === 'HideNA' ? true : false,
                  isdropDown: false,
                  options: []
                }
              );
            }
            else if (e != "ColumnHeaderSorting" && e != "TrendlineinExports" && e != "showLegend") {
              this.elementListItems.push(
                {
                  item: e,
                  selected: false,
                  isdropDown: false,
                  options: [
                    { item: "Ascending", selected: false },
                    { item: "Descending", selected: false },
                    { item: "Default", selected: true },
                  ]
                }
              );
            }
          })
        }
        // Sort this.elementListItems based on chartOptions
        this.elementListItems = this.elementListItems
          .map((item: any) => {
            // Find the matching object from chartOptions
            const matchedOption = this._customService.elementLists.find(option =>
              option.name.replace(/\s+/g, '').toLowerCase() === item.item.replace(/\s+/g, '').toLowerCase()
            );

            // If a match is found, add the label and sortId
            if (matchedOption) {
              return {
                ...item,
                label: matchedOption.name, // Add label from chartOptions
                sortId: matchedOption.sortId // Add sortId from chartOptions
              };
            }

            // If no match, return the item with a high sortId to move it to the end
            return {
              ...item,
              label: item.item, // Use the item name as the label
              sortId: Number.MAX_SAFE_INTEGER
            };
          })
          .sort((a: any, b: any) => a.sortId - b.sortId); // Sort based on sortId

        // const chartType = this.data?.chartType || this.widgetchartname;
        //   if ((chartType?.toLowerCase() === 'propeller' || this.widgetchartname?.toLowerCase() === 'propeller chart') &&!this._configService.selectedSnapshotType?.toLowerCase().includes('multi')) {
        //     this.data.trendlineOutputView = 1;
        //   } else {
        //     this.data.trendlineOutputView = this.customization?.trendlineOutputView;
        //   }
        this.data.elementList = this.elementListItems;
        this.data.sortingOrder = 0;
        this.data.elementList.forEach((item:any) => {
          if(item.item == "Sorting"){
            this.isSortAvailable = true;
          }
        })
        if (this._configService.selectedSnapshotType.toLowerCase().includes("multi")) {
          if (!this.data.metric.some((dd: any) =>
            dd.metric_value.some((mv: any) => mv.data.some((data: any) => data.hasOwnProperty('defaultIndex')))
          )) {
            // If 'defaultIndex' doesn't exist in any data entry, add it with incremental values starting from 0
            this.data.metric = this.data.metric.map((dd: any) => ({
              ...dd,
              metric_value: dd.metric_value.map((mv: any) => ({
                ...mv,
                data: mv.data.map((data: any, index: number) => ({
                  ...data,
                  defaultIndex: index // Assign incremental value starting from 0
                }))
              }))
            }));
          }
        }

      }
    }
    if (changes['data'] || changes['multimetricselect']) {

      if (this.multimetricselect ) {
        this.metricdropdownOutput = this.data.metricdropdownOutput != 0 && !!this.data.metricdropdownOutput;
        const savedMetric = this._customService.getSelectedMetricSync(this.id.toString());
        const defaultOption = this.data.metric[0].metric_value[0]?.option || '';
        const resolvedMetric = (savedMetric && this.data.metric[0].metric_value.some((mv: any) => mv.option === savedMetric))
          ? savedMetric
          : defaultOption;
        const metrics = this.data.metric[0].metric_value;
        const uniqueMetrics = this._customService.uniqueMetricOptions || [];
        
        this.metricList = (
              uniqueMetrics.length > 0
                ? metrics.filter((mv: any) =>
                   mv.typeofmetric && mv.typeofmetric === "CUSTOM METRICS"
                   ? true :
                    uniqueMetrics.some((um: string) =>
                      um?.trim() === this.extractLabel(mv.option) ||
                      (mv.data?.length > 0 &&
                        mv.data.some((d: any) =>
                          d.data !== undefined && d.data != null && d.data !=""
                        ))
                    )
                  )
                : metrics
            ).map((mv: any) => ({
              option: mv.option,
              checked: mv.option === resolvedMetric
            }));
        if(this.metricdropdownOutput){
        this.selectedMetric = resolvedMetric;
        this.data.selectedMetric = this.metricList.length >= 1 ? this.selectedMetric : '';
        this._customService.updateSelectedMetric(this.id, this.metricList.length >= 1 ? this.selectedMetric : '');
        this.metricSelected.emit({ widgetchartname: this.widgetchartname, selectedMetric: this.metricList.length >= 1 ? this.selectedMetric : '' });
        }
      } else {
        this.metricList = [];
        this.selectedMetric = undefined;
      }
      this.cachedPopupWidgetName = this.getPopupWidgetName(this.data);
      // Auto-expand when flagged by AskMe redirect
      if (this.data?._autoExpand) {
        delete this.data._autoExpand;
        setTimeout(() => this.showExpandPopupFun(), 0);
      }
    }
    if (changes['id']) {
      this.isSingleFunnelOrMultipleWidget = this.datafromLayout.find((x: any) => x.page == "Page " + this._customService.pageCount)?.selectedLayout == 1 ? (this.widgetchartname == "FUNNEL CHART" || this.widgetchartname == "Trend as Widget" ? true : false) : true;
      this.isSingleFunnel = this.datafromLayout[this.id - 1]?.selectedLayout == 1 && (this.widgetchartname == "FUNNEL CHART") ? true : false;
    }
    if (changes['widgetchartname'] || changes['id']) {
      if(changes['widgetchartname']){
        const widgetchartname  = changes['widgetchartname'].previousValue;
        const isClusterBar = widgetchartname?.toLowerCase().includes('cluster');
        if (isClusterBar && this.isAudienceSnapshot) {
          this.trendlineOutputView = 2;
        }
        const isSpiderChart = widgetchartname?.toLowerCase().includes('spider');
        const isMultipleBrands = this._configService.selectedSnapshotType?.toLowerCase().includes('multi');
        if (isSpiderChart && (isMultipleBrands || this.isAudienceSnapshot)) {
          this.trendlineOutputView = 2;
        }
        const isMultipleMarkets = this._configService.selectedSnapshotType?.toLowerCase().includes('multiple markets');
        const isStackedChart = widgetchartname?.toLowerCase().includes('stack');
        if (isStackedChart && (isMultipleBrands ||isMultipleMarkets || (this.isAudienceSnapshot && this._configService.multiCohort))) {
          this.trendlineOutputView = 2;
        }
        const isFunnelChart = widgetchartname?.toLowerCase().includes('funnel');
        if (isFunnelChart && (isMultipleMarkets ||isMultipleBrands)) {
          this.trendlineOutputView = 2;
        }
      }
      this.isFunnelChart = (this.widgetchartname ?? '').toLowerCase() === 'funnel chart';
      this.isPropellerChart = (this.widgetchartname ?? '').toLowerCase() === 'propeller chart';
    }
  }

  getBrand() {
  if (this.isAudienceSnapshot) {
    return this.selectedBrand;
  }
  const value = this.selectedBrand ?? '';
  const parts = value.split('|').map((p: string) => p.trim());
  if (parts.length >= 3) {
    return parts.slice(-2).join(' | ');
  }
  if (parts.length === 2) {
    return parts[1] || value;   
  }
  return value;   
}




  toogleDropdown() {
    this.isBrandListdropdownOpen = !this.isBrandListdropdownOpen;
  }


  onCloseIconClick(data: any) {
    this.infoClicked = false;
    this.infoTextMessage = "";
  }

  elementListItems: any = [];
  LengthOf(a: any) {
    if (a) {
      if (Array.isArray(a)) {
        // If array contains Sorting entries (either string or objects with an `item` prop), exclude them
        const filtered = a.filter((x: any) => {
          if (typeof x === 'string') return x !== 'Sorting';
          if (x && typeof x === 'object' && x.item) return x.item !== 'Sorting';
          return true;
        });
        return filtered.length;
      }
      else if (typeof a === 'object') {
        const keys = Object.keys(a);
        if (keys.length > 0) {
          // Exclude 'Sorting' key and count only keys whose value is strictly true
          const filteredKeys = keys.filter(k => k !== 'Sorting');

          // If after removing 'Sorting' there are no keys, return 0
          if (filteredKeys.length === 0) return 0;

          // Count keys that are strictly true. Preserve Trendline behavior by counting it as 1 when truthy.
          let countTrue = 0;
          filteredKeys.forEach(k => {
            if (k === 'Trendline') {
              if (a.Trendline) countTrue += 1;
            } else if (k === 'InfoText') {
              if (a[k] && a[k] !== '') countTrue += 1;
            } else {
              if (a[k] === true) countTrue += 1;
            }
          });

          return countTrue;
        }
      }
      return 0;
    } else {
      return 0;
    }
  }
  isBrandListdropdownOpen: boolean = false;
  isMetricDropdownOpen: boolean = false;
  checkBoxesbrandListClicked(event: any, item: any) {
    this.brandList.forEach((b: any) => {
      if (b.option == item.option) {
        b.checked = event.target.checked
        this.selectedBrand = b.option;
        this.cachedBrandDisplay = this.getBrand();
        this._customService.updateSelectedBrand(this.id, this.selectedBrand);
      }
      else {
        b.checked = false;
      }
    })

  }

  checkBoxesMetricListClicked(event: any, item: any) {
    this.metricList.forEach((m: any) => {
      m.checked = m.option === item.option;
    });
    this.selectedMetric = item.option;
    this.cachedPopupWidgetName = this.getPopupWidgetName(this.data);
    this.data.selectedMetric = this.metricList.length >= 1 ? this.selectedMetric : '';
    this._customService.updateSelectedMetric(this.id, this.metricList.length >= 1 ? this.selectedMetric : '');
    this.metricSelected.emit({ widgetchartname: this.widgetchartname, selectedMetric: this.metricList.length >= 1 ? this.selectedMetric : '' });
  }

  showExpandPopupFun() {

    //this.infoTextTitle = this.widgetName;

    if (this.data?.widgetchart_name === 'Trend as Widget') {
      // Open the same trend popup as when Trendline is clicked
      this.originalWidgetChartName = this.data.widgetchart_name;

      // Restore trendOutputDbCallData from this widget's own metric data,
      // in case it was overwritten by another widget's trendline click.
      const rawData: any[] = [];
      if (this.data.metric) {
        this.data.metric.forEach((metric: any) => {
          if (metric.metric_value) {
            metric.metric_value.forEach((mv: any) => {
              if (mv.data) {
                mv.data.forEach((d: any) => rawData.push(d));
              }
            });
          }
        });
      }
      this._configService.trendOutputDbCallData = rawData;

      const m = _.cloneDeep(this.data);
      m.widgetchart_name = 'Line Chart';

      // const metricList = m.metric.flatMap((metric: any) =>
      //   metric.metric_value.map((mv: any) => mv.option != undefined ? mv.option : mv.metricName)
      // );
      const uniqueMetrics = this._customService.uniqueMetricOptions || [];

      const metricList = m.metric.flatMap((metric: any) =>
        metric.metric_value
          .filter((mv: any) =>
            mv.typeofmetric && mv.typeofmetric === "CUSTOM METRICS"
            ? true :
            uniqueMetrics.length > 0
              ? uniqueMetrics.some((um: string) =>
                  um?.trim() === this.extractLabel(mv.option ?? mv.metricName) ||
                  (mv.data?.length > 0 &&
                    mv.data.some((d: any) => d.data != null && d.data !== ""))
                  )
              : true
          )
          .map((mv: any) => mv.option ?? mv.metricName)
      );
        
      const brandList: any[] = Array.from(new Set(m.metric.flatMap((metric: any) =>
        metric.metric_value.flatMap((mv: any) => (mv.data || []).map((d: any) => d.colChild))
      )));

      this.trendData = m;
      this.metricLists = metricList;
      this.brandLists = brandList;
      this.data.widgetchart_name = 'Line Chart';
      this.showTrendPoppup = true;
    } else {
      this.showExpandPopup = true;
    }
  }
  receivedDeleteConfirmation(data: any) {
    this.showExpandPopup = data;

  }

  showelementlist() {
    if (this.LengthOf(this.customization?.additionalGroup) < 1) {
      return;
    }

    this.alldata.forEach((d: any) => {
      if (d != this.data) {
        d.showElementList = false;
      }
    });
    this.data.showElementList = this.data.showElementList == undefined ? true : !this.data.showElementList;
    this.elementList = !this.elementList;

    event?.stopPropagation();
  }
  closeelementList() {
    this.data.showElementList = false;
    this.elementList = false;
    this.isdropDown = false;
    this.data.elementList.forEach((item: any) => {
      if (item.item == "Sorting") {
        item.selected = false;
        item.isdropDown = false;
      }
    })

  }
  closedropdown(item: any) {
    this.isdropDown = false;
    item.selected = false;
    item.isdropDown = false;
  }
  @Output() elementClickedStatus = new EventEmitter();
  @Output() metricSelected = new EventEmitter<{ widgetchartname: string; selectedMetric: string }>();
  currentElementList: any = [];
  showTrendPoppup: boolean = false;
  trendData: any;
  metricLists: any = [];
  brandLists: any = [];


  sortData(){
    this.defaultSorting = ( this.data.sortingOrder + 1 )%3;
    let sortingOrder = this.defaultSorting == 1 ? 'Ascending' : this.defaultSorting == 2  ? 'Descending' : 'Default';
    let data = {
      data: this.data,
      value: sortingOrder.toLowerCase(),
      key: "sort"
    }
    this.elementClickedStatus.emit(data);
  }
  onSortingClick(item:string){
    this.data.elementList.forEach((e:any) => {
      if(e.item == item){
        this.dropDownItems = e.options;
        this.sortData()
      }
    })
  }
  elementItemSelect(item: any, elementList: any, dropdownContainer: any) {
    this.data.elementList.forEach((e: any) => {
      if (e.item != "Sorting" && e.item == item.item) {
        e.selected = !e.selected;
        if (e.item == "InfoText") {
          this.infoTextMessage = this.customization.infoText;
          e.selected = false;
          this.infoClicked = true;
          this.infoTextTitle = this.data?.widget_name
        }
        if (e.item == "XAxisGridlines") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "xaxisgridlines"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "showLegend") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "showLegend"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "FreezeFirstColumn") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "freezeFirstColumn"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "FreezeFirstRow") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "freezeFirstRow"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Transpose") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "Transpose1"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "DataLabelOverlap") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "dataLabelOverlap"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Axes") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "axes"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Sectorfill") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "sectorfill"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        // if (e.item == "TrendlineinExports") {
        //   let data = {
        //     data: this.data,
        //     value: e.selected,
        //     key: "TrendlineinExports"
        //   }
        //   setTimeout(() => {
        //     this.elementClickedStatus.emit(data);
        //   }, 0);
        // }
        if (e.item == "HideNA") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "hideNA"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "YAxisGridlines") {
          let data = {
            data: this.data,
            value: e.selected,
            key: "yaxisgridlines"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == 'Top10') {
          let data = {
            data: this.data,
            value: e.selected,
            key: "top10"
          }
          setTimeout(() => {
            this.elementClickedStatus.emit(data);
          }, 0);
        }
        if (e.item == "Trendline") {
          this.originalWidgetChartName = this.data.widgetchart_name;
          this._loaderService.showLoader();
          // 
                    let widgetchart_name = this.data.widgetchart_name;
          const baseWidgetName = this.data.widget_name?.split(' (')[0].trim();
          let widgetData = this._configService.widgetData.filter((d: any) => d.widget_name == this.data.widget_name || d.widget_name == baseWidgetName);
          this._configService.getOutPutData(this._configService.finalLeftPanelSubmitObject.previewData,
            // this._configService.finalLeftPanelSubmitObject.selectedClient,
            // this._configService.finalLeftPanelSubmitObject.selectedStudy,
            this._configService.getDropdownValues()?.clientName,
            this._configService.getDropdownValues()?.studyName,
            this._configService.finalLeftPanelSubmitObject.significance,
            this._configService.finalLeftPanelSubmitObject.isFilteringActive,
            this._configService.finalLeftPanelSubmitObject.DefaultConfidenceLevel,
            this._configService.finalLeftPanelSubmitObject.isTotalBase,
            this._configService.finalLeftPanelSubmitObject.selectedWeight,
            this._configService.finalLeftPanelSubmitObject.weightColumnName,
            this._configService.finalLeftPanelSubmitObject.isBoostFactor,
            this._configService.finalLeftPanelSubmitObject.SignificanceVsReference,
            this._configService.finalLeftPanelSubmitObject.columnLength,
            this._configService.finalLeftPanelSubmitObject.dataArray,
            this._configService.finalLeftPanelSubmitObject.isBrandAnalysis,
            this._configService.finalLeftPanelSubmitObject.isAggregatedData,
            this._configService.finalLeftPanelSubmitObject.isSemiAggregatedData,
            this._configService.finalLeftPanelSubmitObject.isRespondentLevel,
            this._configService.finalLeftPanelSubmitObject.aggregatedVariables,
            this._configService.finalLeftPanelSubmitObject.istimePeriodWave,
            this._configService.finalLeftPanelSubmitObject.widegtconfigdetails,
            this._configService.finalLeftPanelSubmitObject.indexVsBrandReference,
            this._configService.finalLeftPanelSubmitObject.significanceVsBrandReference,
            true,//this._configService.checkTrendEnabled(this.existingData)
            this._configService.widgetPageData,
            widgetData,
            this._configService.finalLeftPanelInputSelectedObject.page,
            false,
            this._configService.finalLeftPanelSubmitObject.customBaseMetric,
            this._configService.multiCohort
          ).pipe(takeUntil(this.destroy$)).subscribe((result) => {

            if (result.Data != null && result.Data != undefined && result.Data != "") {
              let opData = JSON.parse(result.Data);
              opData.forEach((d: any) => {
                if (d.Level1ColChild?.startsWith('Time Period|')) {
                  d.Level1ColChild = d.Level1ColChild.replace('Time Period|', '');
                }
              })
// if(this._configService.finalLeftPanelInputSelectedObject.compareAcross=="Multiple Brands"){
//   opData = opData.filter((item: any) => item.rowChild === this.selectedMetric);
// }
                  // Find the reference brand's data for each metric
    let referenceDataMap: any = {};
    let count = 0;
    let baseselected = this._configService.getDropdownValues()?.baseType
    let referenceBrand =  this._configService.getDropdownValues()?.selectedIndex;
    opData.forEach((item: any) => {
      if (item.colChild.includes(referenceBrand)) {
        let key = "";
        if (item.isCustomGroup || item.isCustomCalculation) {
          key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`
        }
        else {
          key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
        }
        count++;
        if(this._configService.weightSelected === "Unweighted") referenceDataMap[key] = baseselected.toLowerCase() !== "total base" ? item.answerUnweightedShare : item.totalUnweightedShare;
        else referenceDataMap[key] = baseselected.toLowerCase() !== "total base" ? item.answerWeightedShare : item.totalWeightedShare;
      }
    }
    );

    //adding NA to reference data for 0 or null value
    Object.keys(referenceDataMap).forEach(key => {
      if (referenceDataMap[key] === null || referenceDataMap[key] === 0) {
        referenceDataMap[key] = "NA";
      }
    });

              //try
              // Create a new array with the divided data
    let newArr = opData.map((item: any) => {
      // Construct the key from rowVariableCode and widgetName
      if (item.widgetName == "Awarenesss") {
        let x = 1;
      }
      let key = "";
      if (item.isCustomGroup || item.isCustomCalculation) {
        key = `${item.rowChild}_${item.rowChild}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`
      }
      else {
        key = `${item.rowChild}_${item.rowVariableCode}_${item.widgetNumber}_${item.pageNumber}_${item.Level1ColChild}`;
      }
      const referenceValue = referenceDataMap[key];

      if (referenceValue !== undefined) {
        if (this._configService.weightSelected === "Weighted" ||
           this._configService.weightSelected == "Weight 1" ||
           this._configService.weightSelected == "weightB" ) {
          return {
            ...item,
            totalWeightedShareIndex: referenceValue === "NA"
              ? null
              : baseselected.toLowerCase() === "total base"
                ? (item.totalWeightedShare / referenceValue) * 100
                : item.totalWeightedShare,
            answerWeightedShareIndex: referenceValue === "NA"
              ? null
              : baseselected.toLowerCase() === "answer base"
                ? (item.answerWeightedShare / referenceValue) * 100
                : item.answerWeightedShare,
            ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
          };
        } else if (this._configService.weightSelected === "Unweighted") {
          return {
            ...item,
            totalWeightedShareIndex: referenceValue === "NA"
              ? null
              : baseselected.toLowerCase() === "total base"
                ? (item.totalUnweightedShare / referenceValue) * 100
                : item.totalUnweightedShare,
                answerWeightedShareIndex: referenceValue === "NA"
              ? null
              : baseselected.toLowerCase() === "answer base"
                ? (item.answerUnweightedShare / referenceValue) * 100
                : item.answerUnweightedShare,
              ...(this._configService.isIndexSelected && { CalculationTypeIndex: "index" })
          };
        }
      }


      return item;
    });
opData = newArr;
              //end
              this._configService.trendOutputDbCallData = opData;
             
              // Exclude the extra "index reference" row for Audience Snapshot, unless the
              // reference audience was also explicitly selected for display.
              const isAudienceSnapshotTrendline = this._configService.selectedSnapshotType?.toLowerCase()?.includes('audience');
              const audienceRefColChildTrendline: string = isAudienceSnapshotTrendline
                ? (opData.find((item: any) => item.colChild && referenceBrand && item.colChild.includes(referenceBrand))?.colChild ?? '')
                : '';
              const selectedAudienceListTrendline: string[] = (this._configService.finalLeftPanelSubmitObject?.LeftPanelSelectedAudience || [])
                .filter((val: string) => val?.trim() !== '');
              const referenceAlsoSelectedForDisplayTrendline = !!audienceRefColChildTrendline
                && selectedAudienceListTrendline.includes(referenceBrand);

              this.showTrendPoppup = true;
              let m = _.cloneDeep(this._configService.itemWithTrendData[0].find((d: any) => d.widget_name == this.data.widget_name || d.widget_name == baseWidgetName));
              //let m = _.cloneDeep(this._configService.itemWithTrendData[0].find((d: any) => d.widget_name == this.data.widget_name));
              
              const isMultipleBrands = this._configService.finalLeftPanelInputSelectedObject.compareAcross == "Multiple Brands";
              m.metric.forEach((metric: any) => {
                metric.metric_value.forEach((mv: any) => {
                  mv._displayLabel = mv.data?.[0]?.rowChild || mv.metricName || mv.option;
                });
              });
             
              m.metric.forEach((metric: any) => {
                metric.metric_value.forEach((mv: any) => {
                  let opDataMetric = opData.filter((d: any) =>
                    ((d.rowChild?.replace(/\s+/g, '')?.toLowerCase().includes(mv.option?.replace(/\s+/g, '')?.toLowerCase())) ||
                    (d.rowChild?.replace(/\s+/g, '')?.toLowerCase().includes(mv.metricName?.replace(/\s+/g, '')?.toLowerCase())))
                    && !(isAudienceSnapshotTrendline && !referenceAlsoSelectedForDisplayTrendline
                        && audienceRefColChildTrendline && d.colChild === audienceRefColChildTrendline)
                  );
                  opDataMetric = opDataMetric.map((d: any) => {
                    return {
                      ...d, // Keep all existing properties
                      data: this._configService.weightToggle(
                        this._configService.getDropdownValues()?.baseType,
                        this._configService.weightSelected,
                        d
                      ),
                      data2: this._configService.weightToggleIndex(
                        this._configService.getDropdownValues()?.baseType,
                        this._configService.weightSelected,
                        d
                      ),
                      lvl1Child: d.Level1ColChild,
                      colChild: d.colChild,
                      rowChild: d.rowChild
                    };
                  });

                  if(opDataMetric){
                    mv.data = opDataMetric;
                    this._configService.sortTrendTimeporiodData(mv.data);
                  }
                });
              })

              if (m) {
  m.widgetchart_name = 'Line Chart';
  let metricList: any;
  if (widgetchart_name == "spider/radar") {
    metricList = m.metric.flatMap((metric: any) =>
      metric.metric_value.map((m: any) => m.option != undefined ? m.option : m.metricName)
    );
  }
  else {
  //   metricList = m.metric.flatMap((metric: any) =>
  //     metric.metric_value.map((mv: any) => mv.metricName ?? mv.option)
  //   );
  // }
    const uniqueMetrics = this._customService.uniqueMetricOptions || [];
     //metricList = metricList.filter((item: any) => uniqueMetrics.includes(item.trim()));
    const allMetricValues = m.metric.flatMap((metric: any) => metric.metric_value);   
    const filteredByUnique = uniqueMetrics.length > 0 ? allMetricValues.filter((mv: any) =>  mv.typeofmetric && mv.typeofmetric === "CUSTOM METRICS"
            ? true : uniqueMetrics.some((um: string) => um?.trim() === this.extractLabel(mv.metricName ?? mv.option))) : [];  
    const filteredMvs = filteredByUnique.length > 0 ? filteredByUnique : allMetricValues.filter((mv: any) => mv.data?.some((d: any) => d.data != null && d.data !== ""));
    metricList = filteredMvs.map((mv: any) => mv.metricName ?? mv.option);
  }

                let brandList = Array.from(new Set(m.metric.flatMap((metric: any) =>
                  metric.metric_value.flatMap((m: any) => m.data.map((d: any) => d.colChild))
                )));
                this.trendData = m;
                
                this.metricLists = metricList;
           
                this.brandLists = brandList
              }
              this.data.widgetchart_name = 'Line Chart';
            }
            this._loaderService.hideLoader();
          });
          e.selected = false;
        }
      }
      else if ((e.item == "Sorting") && e.item == item.item) {
        e.selected = !e.selected;
        e.isdropDown = !e.isdropDown;
        this.isdropDown = e.isdropDown;
        this.dropDownItems = e.options;
        if (e.isdropDown) {
          this.toggleDropdown1(e.isdropDown, elementList, dropdownContainer);
        }
      }
      // else {
      //   if (e.isdropDown) {
      //     // e.selected = false;
      //     e.isdropDown = false;
      //     this.isdropDown = false;
      //   }
      // }
    })
    this._customService.elementListItems = _.cloneDeep(this.elementListItems);
    event?.stopPropagation();
  }
  showDropdown: boolean = false;
  @ViewChild('dropdownContainer') dropdownContainer!: ElementRef;
  private mergeAdditionalKpiIntoMetrics(metricsAvailable: any[], widget: any): any[] {
    const extra = widget?.additionalKPI;
    if (!Array.isArray(extra) || extra.length === 0) {
      return metricsAvailable;
    }
    const kpiBlock = extra.find((k: any) => {
      const opt = k?.kpi_option;
      if (opt == null) {
        return false;
      }
      // Align with chart-output bindCustomization / save payload
      return String(opt).replace(' : ', '') === 'Additional KPI';
    });

    if (!kpiBlock?.kpi_value?.length) {
      return metricsAvailable;
    }

    let kpiList: any[] = [];
    try {
      const raw = kpiBlock.kpi_value[0];
      kpiList =
        typeof raw === 'string'
          ? JSON.parse(raw || '[]')
          : Array.isArray(raw)
            ? raw
            : [];
    } catch {
      return metricsAvailable;
    }

    if (!Array.isArray(kpiList) || kpiList.length === 0) {
      return metricsAvailable;
    }

    const merged = [...metricsAvailable];
    let maxOrder = merged.reduce(
      (m, x) => Math.max(m, Number(x?.selectOrder) || 0),
      0
    );
    for (const kpi of kpiList) {
      const opt = kpi?.option;
      if (opt == null || opt === '') {
        continue;
      }
      const existingIndex = merged.findIndex((m) => m.option === opt);
      if (existingIndex !== -1) {
        // Already in the standard metrics list — mark it as the KPI overlay
        merged[existingIndex] = { ...merged[existingIndex], isAdditionalKPI: true };
        continue;
      }
      merged.push({
        ...kpi,
        selectOrder:
         
             ++maxOrder,
        data: Array.isArray(kpi.data) ? kpi.data : [],
        isAdditionalKPI: true,   // ← ADD THIS
      });
    }
    return merged;
  }
  toggleDropdown1(isDropdown: any, elementList: any, dropdownContainer: any): void {
    this.showDropdown = !this.showDropdown;
    if (isDropdown) {
      // Calculate position of the clicked parent element
      const rect = elementList?.getBoundingClientRect();

      setTimeout(() => {
        const dropdown = this.dropdownContainer.nativeElement;
        // Calculate available space
        const viewportWidth = window.innerWidth;
        const dropdownWidth = dropdown.offsetWidth;

        let leftPosition: number;

        if (rect.right + dropdownWidth <= viewportWidth) {
          // Enough space on the right
          leftPosition = rect.right;
        } else {
          // Not enough space, position to the left
          leftPosition = rect.left - dropdownWidth;
        }

        // Set dropdown position
        this.renderer.setStyle(dropdown, 'position', 'fixed');
        this.renderer.setStyle(dropdown, 'top', `${rect.top}px`);
        this.renderer.setStyle(dropdown, 'left', `${leftPosition - 10}px`);
        this.renderer.setStyle(dropdown, 'z-index', '10');
        this.renderer.setStyle(dropdown, 'visibility', 'visible'); // Make sure dropdown is visible
      })



    }
  }

  getUniqueBrand(brandList: any[]): any[] {
    const seen = new Set<string>();
    return brandList.filter((item) => {
      if (seen.has(item.option)) {
        return false;
      }
      seen.add(item.option);
      return true;
    });
  }


  checkElementStatus() {
    if (this.elementList && this.LengthOf(this.customization?.additionalGroup) > 0) {
      if (this.LengthOf(this.customization?.additionalGroup) == 1) {
        if (Object.keys(this.customization?.additionalGroup).includes("InfoText")) {
          if (this.customization?.additionalGroup?.InfoText != "") {
            return true;
          }
          else {
            return false;
          }
        }
        else {
          return true;
        }
      }
    }
    else {
      return false;
    }
    return true;
  }

  dropDownSelect(item: any) {
    this.dropDownItems.forEach((d: any) => {
      if (d.item == item.item) {
        d.selected = true;
        let data = {
          data: this.data,
          value: d.item.toLowerCase(),
          key: "sort"
        }
        this.elementClickedStatus.emit(data);
        this.data.elementList.forEach((item: any) => {
          if (item.item == "Sorting") {
            item.selected = false;
            item.isdropDown = false;
          }
        })
      }
      else {
        d.selected = false;
      }
    })
    event?.stopPropagation();
  }


  hide(data: any) {
    this.showTrendPoppup = data;
    this.data.widgetchart_name = this.originalWidgetChartName;
  }

  updateDataBars(item: any, status: boolean) {
    this.dataBarsUpdated.emit({ item, status });
  }

  getPopupWidgetName(item: any): string {
    if (!item?.widget_name) {
      return '';
    }

    let widgetName = item.widget_name;
    if (this.metricdropdownOutput && this.metricList?.length > 1 && this.selectedMetric) {
      widgetName = `${widgetName} - ${this.selectedMetric}`;
    }

    const isAudienceSnapshot =
      this._configService.selectedSnapshotType?.toLowerCase()?.includes('audience');

    if (!isAudienceSnapshot) {
      return widgetName;
    }

    if (item?.audience != null) {
      return widgetName;
    }

    const brandLabel = this.getSelectedBrandLabel(item);

    if (!brandLabel) {
      return widgetName;
    }

    if (widgetName.includes(brandLabel)) {
      return widgetName;
    }

    return `${widgetName} <span class="itemBrandLabel">${brandLabel}</span>`;
  }

 getSelectedBrandLabel(item: any): string {
  // If audience is NOT null, return empty string
  if (item?.audience != null) {
    return '';
  }

  const value =
    this._configService?.finalLeftPanelSubmitObject?.previewData
      ?.Audiencebrand?.[0]?.option;

  if (!value) {
    return '';
  }
  const parts = value.split('|').map((p: string) => p.trim());
  const label =
    parts.length >= 3
      ? parts.slice(-2).join(' | ')
      : parts.length === 2
        ? parts[1]          
        : parts[0];

  return `(${label})`;
}

 extractLabel = (val?: string) => {
  if (!val) return val;
  const parts = val.split('|');
  return (parts.length > 1 ? parts[1] : parts[0]).trim();
};
}